<div class="Customers overview-loyalty ui-g">

    <div class="ui-g-12 ui-lg-6">
        <h1 class="step-title">{{'customers.revenue_analysis_title' | translate}}</h1>
    </div>
    <div class="ui-g-12 ui-lg-12">
        <p-steps [model]="types" [(activeIndex)]="activeIndex" [readonly]="false"></p-steps>
        <kv-search-toolbar
                [date_structure]="searchModel.date_structure"
                [card_modes]="searchModel.card_modes"
                [clusters]="searchModel.cluster_list"
                [clusterFieldEnabled]="false"
                [selectedElapsedStart]="searchModel.selectedStartDate"
                [selectedElapsedEnd]="searchModel.selectedEndDate"
                [group_types]="searchModel.group_types"
                [groups]="searchModel.groups"
                [areas]="searchModel.areas"
                [stores]="searchModel.stores"
                [product_categories]="svcStore.categories"
                [product_subsectors]="svcStore.subsectors_tree"
                appQFilter
                (onQFilter)="ApplyResult($event)"
        ></kv-search-toolbar>

        <div class="overview-container card ui-g-nopad">
            <app-revenue-analysis-tree [hidden]="activeIndex !== 0"></app-revenue-analysis-tree>
            <app-revenue-analysis-trend [hidden]="activeIndex !== 1"></app-revenue-analysis-trend>
        </div>

    </div>

</div>



// WEBPACK FOOTER //
// ./src/app/views/customerDB/revenue-analysis/revenue-analysis.component.html